// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2PJ_g","boxTitle":"Qualiphy_boxTitle__1hErI","box":"Qualiphy_box__cxO96","toggleWrap":"Qualiphy_toggleWrap__18eFn"};